import { Routes, Route, Navigate } from'react-router-dom';
import { Layout } from'./components/layout/Layout';
import { Home } from'./pages/Home';
import Demo from'./pages/Demo';

function App() {
 return (
 <Routes>
 <Route element={<Layout />}>
 <Route path="/" element={<Home />} />
 <Route path="/demo" element={<Demo />} />
 <Route path="/demo/:step" element={<Demo />} />
         {/* An unknown path lands on the home page. Without this, BrowserRouter
            renders nothing at all and the visitor sees a blank page. */}
        <Route path="*" element={<Navigate to="/" replace />} />
</Route>
 </Routes>
 );
}

export default App;
